import { MailService } from '@/services/MailService'


export const state = {
  templates: [],
  registrations: [],
}
export const mutations = {

  setTemplates(currentState, templates) {
    currentState.mail.templates = templates
  },
  setRegistrations(currentState, registrations) {
    currentState.mail.registrations = registrations
  },
}
export const actions = {
  getTemplates({ rootState, commit }) {
    MailService.getTemplates().then((templates) => {
      commit('setTemplates', templates)
    })
  },
  getRegistrations({ rootState, commit }) {
    const clientid = rootState.authentication.userProfile.attributes.hublot_clientid[0]
    MailService.getRegistrations(clientid).then((registrations) => {
      commit('setRegistrations', registrations)
    })
  },
  addRegistration({ rootState, commit, dispatch }, registration) {
    const clientid = rootState.authentication.userProfile.attributes.hublot_clientid[0]
    MailService.addRegistration({ ...registration, clientId: clientid }).then(() => {
      dispatch('getRegistrations')
    })
  },
  deleteRegistration({ rootState, commit, dispatch }, registration) {
    MailService.deleteRegistration(registration).then(() => {
      dispatch('getRegistrations')
    })
  },
}
export default { state, actions, mutations }
